const filterGroups = {
  'filter-groups-breadcrumbs': 'Filter groups',
  'filter-groups-structured-type-field': 'Structured type',
  'filter-groups-form-filters-field': 'Filters',
  'filter-groups-form-filters-hint': 'This field accepts filters',
  'filter-groups-form-filters-placeholder': 'Choose filters',
  'filter-groups-filters-priority': 'Filters priority',
  'filter-groups-filters-priority-help': 'Set the desired priority of filters',
  'filter-groups-filters-not-selected': 'Filters not selected',
  'filters-filter-group-title': 'Filters group',
  'filters-attached-to-collections': 'Cannot delete the filter group as it is used in collections: ',
};

export default filterGroups;
